import { Link } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import { SectionHeader } from '../../components/molecules/SectionHeader/SectionHeader';
import { servicesData } from '../../data/services';
import styles from './Services.module.css';

export function Services() {
  const { ref, inView } = useInView();

  return (
    <section className={styles.section} id="services">
      <div className="wrap">
        <div ref={ref} className={`reveal ${inView ? 'visible' : ''}`}>
          <SectionHeader eyebrow="Services" title="서비스 상세" dark />
        </div>
        <div className={styles.stack}>
          {servicesData.map((svc, i) => (
            <ServiceCard key={svc.n} service={svc} index={i} flip={i % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, index, flip }) {
  const { ref, inView } = useInView();

  return (
    <div
      ref={ref}
      className={`${styles.card} ${flip ? styles.flip : ''} reveal ${inView ? 'visible' : ''}`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      {/* Image */}
      {service.img && (
        <div className={styles.imgWrap}>
          <img src={service.img} alt={service.imgAlt} className={styles.img} />
          <div className={styles.imgMeta}>
            <span className={`${styles.cat} ${styles[service.catClass]}`}>{service.cat}</span>
            <span className={styles.num}>{service.n}</span>
          </div>
        </div>
      )}

      {/* Content */}
      <div className={styles.body}>
        <h3 className={styles.title}>{service.title}</h3>
        <p className={styles.desc}>{service.desc}</p>
        <ul className={styles.detailList}>
          {service.details.map((d, i) => (
            <li key={i} className={styles.detailItem}>
              <span className={`${styles.dot} ${d.dotClass === 'g' ? styles.dotGold : ''}`} />
              <div className={styles.dLbl}>{d.label}</div>
            </li>
          ))}
        </ul>
        {service.slug && (
          <Link to={`/services/${service.slug}`} className={styles.detailLink}>
            자세히 보기
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        )}
      </div>
    </div>
  );
}
